<div (click)="goToContact()" class="dashboard-contact or-mx-16-px or-mt-12-px border-radius-4 or-cursor-pointer">
  <or-icon name="contact" size="s" square class="dashboard-contact__icon" />

  <div class="dashboard-contact__body">
    <div class="or-head-sm">Skontaktuj się z nami</div>
    <ul class="dashboard-contact__list or-text-sm or-color-secondary-2 or-mt-4-px">
      @for (reason of reasons; track reason) {
        <li>{{ reason }}</li>
      }
    </ul>
  </div>

  <or-icon name="chevron-right" size="xs" class="or-color-secondary-2" />
</div>
